import React, { useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../../assets/css/Profile.css";
import SideBar from "../../Components/SideBar/SideBar";
import { Link, useNavigate } from "react-router-dom";
import TopBar from "../../Components/SideBar/TopBar";
import { arrow } from "../../constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { GetCustomerMemberShip, GetCustomerOrders, GetMembership } from "../../network/Network";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";

function MyMemberShip() {
	const Token = useSelector((state) => state.AuthReducer.token);
	const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
	const [newFile, setNewFile] = useState("");
	const [fileupload, setFileupload] = useState("");
	const [uploadLoading, setUploadLoading] = useState(false);
	const [orderAll, setOrderAll] = useState(null);
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const handleImageUpload = (e) => {
		e.preventDefault();
		const reader = new FileReader();
		const file = e.target.files[0];
		reader.onloadend = () => {
			setNewFile(file);
			setFileupload(reader.result);
		};
		reader.readAsDataURL(file);
		setUploadLoading(true);
	};


	useEffect(() => {
		setLoading(true);
		GetCustomerMemberShip(Token)
			.then((res) => {
				setOrderAll(res?.data?.response?.data?.data);
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
			})
	}, []);

	const EditProfile = (e) => {
		e.preventDefault();
	};

	const changePassword = (e) => {
		e.preventDefault();
	};

	return (
		<>
			<Header />
			{/* <!-- Universal Banner Sec End Here --> */}
			<section className="profile">
				<div className="container">
					<div className="row profile-row">
						<SideBar
							uploadLoading={uploadLoading}
							fileupload={fileupload}
							handleImageUpload={handleImageUpload}
						/>
						<div className="col-lg-9">
							<div className="tab-content" id="v-pills-tabContent">
								<div
									className="tab-pane fade active show"
									id="pills-home"
									role="tabpanel"
									aria-labelledby="pills-home-tab"
								>
									<TopBar />
									<div className="row">
										{/* <div className="Accounts">
											<h5>My MemberShip</h5>
										</div> */}
									</div>
									<div className="row info-profile">
									<h3 className="form-heading heading-top-cont">
												My Membership
											</h3>
										<div className="col-md-12 rightSide-profile">
											{
												loading
													?
													<Skeleton count={8} />
													:
													<>
														{orderAll?.map((item, index) => {
															if (item.membership?.heading === "CSA Membership") {
																return (
																	<div key={index + 84962} className="row mt-2">
																		<div className="col-lg-6">
																			<p className="familyMember-Title">CSA Membership</p>
																			<p className="familyMember-expiry">
																				Purchase date: {item?.created_at.slice(0, 10)}
																			</p>
																			<p className="familyMember-expiry">
																				Duration : {item?.csa_product_price?.type}
																			</p>
																		</div>
																		<div className="col-lg-6">
																			<div className="familyMember-Title">
																				<button
																					className="btn cancel-memberBtn cancel-memberBtn2"
																					onClick={() => navigate(`/csa-member/${item.id}`, { state: item })}
																				>
																					VIEW DETAILS &nbsp;&nbsp;
																				<img src={arrow} alt="" className="image-fluid" />
																				</button>
																			</div>
																		</div>
																	</div>
																)
															} else if(item?.membership?.heading === "Family Membership") {
																return (
																	<div className="row mt-2">
																		<div className="col-lg-6">
																			<p className="familyMember-Title">
																				Family Membership
																	</p>
																			<p className="familyMember-expiry">
																				Purchase date: {item?.created_at.slice(0, 10)}
																			</p>{" "}
																			<p className="familyMember-expiry">
																				Duration : 1 Year Membership
																	</p>
																		</div>
																		<div className="col-lg-6">
																			<div className="familyMember-Title">
																				<button
																					className="btn cancel-memberBtn mt-2"
																					onClick={() => navigate(`/family-member-details/${item.id}`, { state: item })}
																				>
																					VIEW DETAILS &nbsp;&nbsp;
																			<img src={arrow} alt="" className="image-fluid" />
																				</button>
																			</div>
																		</div>
																	</div>
																)
															}else{
																return <h2 className="no_mombership_found">No Membership found</h2>
															}
														})}
													</>
											}
											{/* <hr /> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
}

export default MyMemberShip;
